import React from 'react';
import { useTranslation } from 'react-i18next';

const Terms: React.FC = () => {
  const { t } = useTranslation('terms');

  return (
    <div className="min-h-screen bg-white px-6 py-10 max-w-2xl mx-auto">
      <h1 className="text-2xl font-bold text-gray-900 mb-6">
        {t('title')}
      </h1>
      <p className="text-gray-500 text-sm mb-6">
        {t('lastUpdated')}
      </p>

      <div className="prose prose-sm text-gray-700 space-y-4">
        <p>
          {t('paragraphs.intro')}
        </p>

        <p>
          {t('paragraphs.modifications')}
        </p>

        <p className="border-l-4 border-green-500 pl-4 bg-green-50 py-2 font-medium text-green-800">
          {t('paragraphs.easterEgg')}
        </p>

        <p>
          {t('paragraphs.eligibility')}
        </p>

        <p>
          {t('paragraphs.dataProtection')}
        </p>

        <p>
          {t('paragraphs.prize')}
        </p>

        <p>
          {t('paragraphs.winner')}
        </p>

        <p>
          {t('paragraphs.liability')}
        </p>

        <p>
          {t('paragraphs.jurisdiction')}
        </p>

        <p>
          {t('paragraphs.law')}
        </p>

        <p className="text-gray-400 text-xs mt-8">
          {t('copyright')}
        </p>
      </div>
    </div>
  );
};

export default Terms;
